@if (recommendedUnis$ | async; as unis) {
	<h2 class="text-xl leading-[30px] font-bold border-t pt-5">
		Recommended universities
	</h2>
	<p class="mt-2 mb-5 text-base font-normal leading-6 text-gray-500">
		Based on your uni choice, we think you’ll like these too! Get in touch with the
		universities today.
	</p>
	@for (uni of unis; track uni.id) {
		<div
			class="flex items-center justify-between w-full gap-3 pb-5 mb-5 border-b"
			[ngClass]="{ 'last:border-b-0 pb-0 mb-0': isInAppBrowser() }"
		>
			<div class="flex items-center gap-3">
				<a
					ucUniProfileGA
					[eventTypes]="['click']"
					[uniId]="uni.id"
					[uniName]="uni.name"
					[ugSearchOrderPosition]="uni.order"
					[cleSearchOrderPosition]="null"
					[product]="product()"
					[routerLink]="['/universities', uni.slug]"
					class="relative flex-shrink-0 block w-12 h-12 bg-white border rounded-lg"
					data-cy="university-logo-link"
				>
					<img
						[ngSrc]="uni.logo | cdn"
						fill
						[attr.alt]="'Logo of ' + uni.name"
						class="object-contain rounded-lg"
					/>
				</a>
				<div class="flex flex-col">
					<p class="text-base font-bold leading-6">
						<a
							[routerLink]="['/universities', uni.slug]"
							ucUniProfileGA
							[eventTypes]="['click']"
							[uniId]="uni.id"
							[uniName]="uni.name"
							[ugSearchOrderPosition]="uni.order"
							[cleSearchOrderPosition]="null"
							[product]="product()"
							data-cy="university-name-link"
							>{{ uni.name }}</a
						>
					</p>
					@if (uni.stats.recommended_percentage; as recommended) {
						<p class="text-sm font-normal leading-[21px] text-gray-500">
							{{ recommended }}% Recommended
						</p>
					}
				</div>
			</div>
			@if (isInAppBrowser()) {
				<button
					type="button"
					(click)="onRequestInfoClick(uni.id, uni.order)"
					class="inline-flex items-center justify-center whitespace-nowrap primary-green-btn focus:outline-none sm:w-auto"
				>
					Request info
				</button>
			} @else {
				<uc-request-btn
					[params]="uni.id"
					[componentName]="componentName"
					customStyles="w-full sm:w-full"
					[product]="product()"
					[buttonText]="'Request info' | abbrButtonText: 'Request'"
					[ugSearchOrderPosition]="uni.order"
				/>
			}
		</div>
	}
}
